import { IconButton, Typography } from '@mui/material';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import { Box } from '@mui/system';
import AvatarUser from './AvatarUser';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        /*width: `calc(100% - ${drawerWidth}px)`,*/
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#00A7DB',
        },
    },
});

const handleClick = (open, handleDrawerClose, handleDrawerOpen, handlerDrawerFixed) => {

    handlerDrawerFixed();

    if (open === true) {
        handleDrawerClose("N");
    }
    else {
        handleDrawerOpen();
    }
}

const Navbar = ({ open, handleDrawerOpen, handleDrawerClose, handlerDrawerFixed }) => {


    return (
        <ThemeProvider theme={darkTheme}>
            <AppBar position="fixed" open={open} color="primary" enableColorOnDark>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => { handleClick(open, handleDrawerClose, handleDrawerOpen, handlerDrawerFixed) }}
                        edge="start"
                        sx={{
                            marginRight: 5,
                            // ...(open && { display: 'none' }),
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h5" noWrap component="div" >
                        <img src="./img/esco-bolsa.png" width={200} alt="esco bolsa" />
                    </Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    {/* <Avatar sx={{mr:1}}><Person3Icon /></Avatar>*/}
                    <AvatarUser />
                </Toolbar>


            </AppBar>
        </ThemeProvider>
    );
};

export default Navbar;